import React from 'react';
import {
  IMeasureCohortFieldsFragment,
  TimeWindowKey,
} from '../../../../utils/apollo/graphqlSchema';
import InfoPopupHeaderSetting from '../InfoPopupHeaderSetting';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { CohortConditionIcon } from '../../../Icon';
import { getCohortPercentileFilterLabel } from '../../../../utils/builder/cohorts';
import { BuilderMeasureInfo } from '../Measures';
import CohortDetailsDateRange from './CohortDetailsDateRange';
import { CohortDetailsBorderedInfo } from './CohortDetailsUI';

interface IProps {
  cohort: IMeasureCohortFieldsFragment;
  cohortIndex: number;
}

export default ({ cohort, cohortIndex }: IProps) => {
  const {
    type,
    operator,
    timeWindow,
    timeWindowValues,
    operatorValues,
    measure,
    percentileFilter,
    datePicker,
    subject,
  } = cohort;

  return (
    <>
      <BuilderInfoUI.HeaderContainer>
        <CohortConditionIcon conditionIndex={cohortIndex} />
        <InfoPopupHeaderSetting label={'Subject'}>
          {subject.name}
        </InfoPopupHeaderSetting>
        <InfoPopupHeaderSetting label={'Type'}>
          {type.name}
        </InfoPopupHeaderSetting>
        <CohortDetailsDateRange datePicker={datePicker} />
        <CohortDetailsBorderedInfo>{operator.name}</CohortDetailsBorderedInfo>
        {operatorValues?.length > 0 && (
          <>
            <CohortDetailsBorderedInfo>
              {operatorValues[0]}
            </CohortDetailsBorderedInfo>
            {operatorValues.length === 2 && (
              <>
                <div>and</div>
                <CohortDetailsBorderedInfo>
                  {operatorValues[1]}
                </CohortDetailsBorderedInfo>
              </>
            )}
          </>
        )}
        {percentileFilter && (
          <InfoPopupHeaderSetting>
            {getCohortPercentileFilterLabel({
              operatorKey: percentileFilter.operator.key,
              operatorName: percentileFilter.operator.name,
              values: percentileFilter.values,
            })}
          </InfoPopupHeaderSetting>
        )}
        <CohortDetailsBorderedInfo>{timeWindow.name}</CohortDetailsBorderedInfo>
        {timeWindowValues?.length > 0 && (
          <>
            <CohortDetailsBorderedInfo>
              {timeWindowValues[0]}
            </CohortDetailsBorderedInfo>
            {timeWindowValues.length === 2 && (
              <>
                <div>and</div>
                <CohortDetailsBorderedInfo>
                  {timeWindowValues[1]}
                </CohortDetailsBorderedInfo>
              </>
            )}
          </>
        )}
        {timeWindow.key !== TimeWindowKey.Overall && (
          <BuilderInfoUI.HighlightedLabel>
            Day(s)
          </BuilderInfoUI.HighlightedLabel>
        )}
      </BuilderInfoUI.HeaderContainer>
      <BuilderMeasureInfo measure={measure} showLabels={false} />
    </>
  );
};
